import _ from 'lodash';
import { gEnums } from '../../enums/globalEnums';
import { getGallery_clientProfiles, get_documentStorageItems } from '../../storage/storageItems';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from './reducerHelpers/dispatchProps';

const rts = {
  handleGet_itemGalleryItems: 'handleGet_itemGalleryItems',
  handleGet_itemPdfs: 'handleGet_itemPdfs',
  handleSet_itemStorageImages: 'handleSet_itemStorageImages',
  handleSet_existingGalleryItems: 'handleSet_existingGalleryItems',
  handleUpdate_itemStorageImage: 'handleUpdate_itemStorageImage',
  ...grts,
}

export const itemStorageReducer = (state, action) => {

  const { mainStorage, pathViews, useClientProfileImage, appUserCollection, clientStorageImageCollections, getImageFromProfileProp, profileImageProp, staticViews, appDataDocuments } = state
  const { type, dispatch } = action

  const { handleSet_itemStorageImages } = itemStorageHandlers(dispatch)

  switch (type) {
    case rts.handleGet_itemGalleryItems:
      if (useClientProfileImage && clientStorageImageCollections && clientStorageImageCollections.includes(action.key_viewItem)) {
        // let allEmails = []
        // _.forEach(clientStorageImageCollections, (imageCollection) => {
        //   const staticView = staticViews[imageCollection]
        //   const appDataDocument = appDataDocuments?.[imageCollection]
        //   const emails = _.map(_.filter(staticView, 'email'), 'email');
        //   const _emails = appDataDocument ? _.map(_.filter(appDataDocument, 'email'), 'email') : [];
        //   const _clientEmails = _emails ? _emails : emails
        //   allEmails = _.concat(allEmails, _clientEmails)
        // })
        // getGallery_clientProfiles(mainStorage, pathViews, appUserCollection, null, handleSet_itemStorageImages, gEnums.storageLocationTypes.clientProfiles, allEmails)
      } else {
        // ZZZZZ
        // get_documentStorageItems(mainStorage, pathViews, action, handleSet_itemStorageImages)
      }
      return { ...state }

    case rts.handleGet_itemPdfs:
      return { ...state }

    case rts.handleSet_itemStorageImages: // internal

      console.log('handleSet_itemStorageImages')
      // existing items
      const { galleryItems: _galleryItems } = state
      const { galleryResponse } = action
      const { galleryItems, galleryPath } = galleryResponse

      let _emailsNotInGalleryItems = []

      // send the results to the storage provider   
      const gis = _galleryItems ? { ..._galleryItems, ...galleryItems } : galleryItems
      return { ...state, galleryItems: gis, updateStoragePath: galleryPath, galleryResponse, nonGalleriedEmails: _emailsNotInGalleryItems }

    case rts.handleSet_existingGalleryItems:
      const _galleryResponse = {
        galleryItems: action.galleryItems,
        galleryPath: action.key_viewItem
      }
      return { ...state, galleryItems: action.galleryItems, updateStoragePath: action.galleryPath, galleryResponse: _galleryResponse }

    case rts.handleUpdate_itemStorageImage: // internal 
      return { ...state }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterUpdate })

    default:
      return state
  }
}

export const itemStorageInitialState = (initState) => {
  return { ...initState, updateStoragePath: null }
};

export const itemStorageHandlers = (dispatch) => {
  return {
    handleGet_itemGalleryItems: (galleryPath, key_viewItem) => { dispatch({ type: rts.handleGet_itemGalleryItems, dispatch, galleryPath, key_viewItem }) },
    handleSet_existingGalleryItems: (galleryItems, key_viewItem, galleryPath) => { dispatch({ type: rts.handleSet_existingGalleryItems, dispatch, galleryItems, key_viewItem, galleryPath }) },
    handleSet_itemStorageImages: (galleryResponse) => { dispatch({ type: rts.handleSet_itemStorageImages, dispatch, galleryResponse }) },
    handleUpdate_itemStorageImage: (galleryPath, key_viewItem) => { dispatch({ type: rts.handleUpdate_itemStorageImage, dispatch, galleryPath, key_viewItem }) },
    ...responseHandlers(dispatch)
  }
} 